import React, { useCallback, useState } from 'react';

import { Container, Button, Table } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';

import Loading from '../../Loading';
import { IDependente } from '../../../pages/CartaoSaudeDetalhe';
import getResponseErrors from '../../../utils/getResponseErrors';

type ComponentProps = {
  PlaCodigo: number;
  updated_at: Date;
  dependentes?: IDependente[];
  geraNovoContrato: boolean;
  handleSalvouTitular(dados: IDependente[]): void;
};

const CartaoSaudeTitular: React.FC<ComponentProps> = ({
  PlaCodigo,
  updated_at,
  dependentes,
  geraNovoContrato,
  handleSalvouTitular,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleTrocaTitular = useCallback(
    async (DepCodigo: number) => {
      setLoading(true);
      try {
        const response = await api.put<IDependente[]>(
          `planos/dependentes/${PlaCodigo}`,
          {
            DepCodigo,
            updated_at,
          },
        );

        handleSalvouTitular(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível atualizar o titular',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [PlaCodigo, updated_at, addToast, handleSalvouTitular],
  );

  return (
    <Container style={{ height: '100%', minHeight: '250px' }}>
      {loading && <Loading />}

      {geraNovoContrato && (
        <div className="alert alert-warning px-3 py-1 mt-2">
          <h5>Atenção!</h5>
          Essa operação írá gerar um novo contrato, começando da parcela 1 até a
          12.
        </div>
      )}

      {dependentes ? (
        <Table className="text-secondary" hover size="sm">
          <thead>
            <tr className="bg-light text-dark">
              <th>Nome</th>
              <th>Parentesco</th>
              <th>Data Adesão</th>
              <th>-</th>
            </tr>
          </thead>
          <tbody>
            {dependentes.map(dep => (
              <tr key={`dep-${dep.DepCodigo}`}>
                <td>{dep.paciente.PacNome}</td>
                <td>{dep.DepParentesco}</td>
                <td>{dep.DepDataInicioFormatado}</td>
                <td>
                  <Button
                    type="button"
                    size="sm"
                    variant="success"
                    onClick={() => handleTrocaTitular(dep.DepCodigo)}
                  >
                    <FaCheckCircle size={14} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <>
          <h6>Nenhum dependente encontrado.</h6>
          <p>
            Caso deseje alterar o titular insira um novo paciente no cartão para
            depois realizar a troca.
          </p>
        </>
      )}
    </Container>
  );
};

export default CartaoSaudeTitular;
